import React, { useState } from 'react';
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  TextField,
  Grid,
  styled,
} from '@mui/material';
import { Link } from 'react-router-dom';//

const StyledTableCellHeader = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontSize: '1.5em',
  // textAlign: 'center',
}));

const StyledTableCellBody = styled(TableCell)(() => ({
  fontSize: '1em',
  // textAlign: 'center',
}));

const TableCustom = ({ columns, rows }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0); // Reset page when search term changes
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  const filteredRows = rows.filter((row) =>
    columns.some((column) =>
      String(row[column.id]).toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const paginationLabels = {
    labelRowsPerPage: 'Linhas por página:',
    labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
  };

  return (
    <Box my={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={6}>
          {/* Deixe este item vazio para criar um espaço à direita */}
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            label="Pesquisar"
            variant="outlined"
            onChange={handleSearchChange}
            value={searchTerm}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableContainer>
            <Table sx={{ minWidth: 700, borderRadius: '5%' }} aria-label="customized table">
              <TableHead>
                <StyledTableRow>
                  {columns.map((column, index) => (
                    <StyledTableCellHeader key={index} align={column.align || 'center'}>
                      {column.label}
                    </StyledTableCellHeader>
                  ))}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => (
                    <StyledTableRow
                      key={rowIndex}
                      sx={{
                        backgroundColor: row.active === 0 ? '#FFCCCC' : 'inherit',
                        '&:nth-of-type(odd)': {
                          backgroundColor: row.active === 0 ? '#FFCCCC' : 'inherit',
                        },
                      }}
                    >
                      {columns.map((column, colIndex) => (
                        <StyledTableCellBody key={colIndex} align={column.align || 'center'}>
                           {/* Check if the column is 'originalname' to render a link */}
                           {column.id === 'originalname' ? ( // If column is 'originalname'
                            <Link style={{color : "#000"}} to={`/readDocument?title=${row[column.id]}`}>{row[column.id]}</Link> // Render link with document ID
                          ) : (
                            row[column.id] // Otherwise, render plain text
                          )}
                        </StyledTableCellBody>
                      ))}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            {...paginationLabels}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableCustom;
